import type { CoreFolderContentsRetrieve, CoreFolderEntityType, CoreFolderRetrieve } from '@lib/types/folder'

export function getCoreFolders(payload: {
  instance_id: string
  entity: CoreFolderEntityType
  parent_id?: string | null
}): Promise<CoreFolderContentsRetrieve> {
  return this.API.request('get_core_folders', payload)
}

export function patchCoreFolder(id: string, payload: Partial<CoreFolderRetrieve>): Promise<CoreFolderContentsRetrieve> {
  return this.API.request('patch_core_folder', {
    id,
    payload,
  })
}
